import { render, staticRenderFns, recyclableRender, components } from "./mine.vue?vue&type=template&id=dcbcfe34&scoped=true&"
var renderjs
import script from "./mine.vue?vue&type=script&lang=js&"
export * from "./mine.vue?vue&type=script&lang=js&"
import style0 from "./mine.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mine.vue?vue&type=style&index=1&id=dcbcfe34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbcfe34",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/mine.vue"
export default component.exports